import $ from 'jquery';

$(document).ready(function() {
  const $body = $('html, body');
  const $accordion = $('.e-accordion');

  //
  $accordion.each(function() {
    const $thisAccordion = $(this);

    $thisAccordion.find('.item-title').on('click', function(event) {
      event.preventDefault();

      const $thisLink = $(this);
      const $item = $thisLink.closest('.item');

      //
      if ($item.hasClass('active')) {
        $item.removeClass('active');
      }
      else {
        $thisAccordion.find('.item.active').removeClass('active');
        $item.addClass('active');

        // Scroll to the active element
        setTimeout(() => {
          $body.animate({
            scrollTop: $item.offset().top - 30
          }, 400);
        }, 400);
      }
    });
  });

});



// WEBPACK FOOTER //
// ./app/ui/elements/accordion/index.js